import { VehicleGrid } from '@/features/VehicleGrid';

export default function VehiclesPage() {
    return <VehicleGrid />;
}
